import React from "react";
import ProgressSvg from "../../../assets/svgicons/progress-bar/progress_bar_3_4.svg";

const Progress_3_4 = (props) => {
  return <img src={ProgressSvg} alt="Progress 3-4" {...props} />;
};

export default Progress_3_4;
